/// <amd-module name="Feed/Core/Components/FeedPickerSelectors" />
import { IListBoxItem } from "VSSUI/ListBox";
import { GroupedItemProvider } from "VSSUI/Utilities/GroupedItemProvider";

import * as PackageResources from "Feed/Common/Resources";
import { IFeedData, IFeedHubViewState } from "Feed/Core/Redux/FeedHub/FeedHubContracts";
import { UxFeedView } from "Feed/Core/UxFeedView";
import * as Reselect from "Reselect";

function getAllFeedData(state: IFeedHubViewState): { [key: string]: IFeedData } {
    return state.data.feeds;
}

function getfeedItemProvider(feeds: UxFeedView[]): GroupedItemProvider {
    const groupIds = {
        PROJECT: PackageResources.FeedPicker_ProjectGroupId,
        COLLECTION: PackageResources.FeedPicker_CollectionGroupId
    };

    const groups = [
        { id: groupIds.PROJECT, name: PackageResources.FeedPicker_ProjectGroupName },
        { id: groupIds.COLLECTION, name: PackageResources.FeedPicker_CollectionGroupName }
    ];
    return new GroupedItemProvider(
        feeds.map(
            (feed): IListBoxItem => {
                return {
                    id: feed.id,
                    text: feed.name,
                    groupId: feed.project ? groupIds.PROJECT : groupIds.COLLECTION
                };
            }
        ),
        groups,
        true
    );
}

export const getActiveFeedsGroupedItemProvider = Reselect.createSelector(
    getAllFeedData,
    (feeds: { [key: string]: IFeedData }) => {
        let activeFeeds: UxFeedView[] = [];

        for (const feed of Object.keys(feeds)) {
            const feedValue = feeds[feed];
            if (feedValue.feed.deletedDate == null) {
                activeFeeds.push(new UxFeedView(feedValue.feed));
            }
        }
        return getfeedItemProvider(activeFeeds);
    }
);

export const getDeletedFeedsGroupedItemProvider = Reselect.createSelector(
    getAllFeedData,
    (feeds: { [key: string]: IFeedData }) => {
        let deletedFeeds: UxFeedView[] = [];

        for (const feed of Object.keys(feeds)) {
            const feedValue = feeds[feed];
            if (feedValue.feed.deletedDate != null) {
                deletedFeeds.push(new UxFeedView(feedValue.feed));
            }
        }
        return getfeedItemProvider(deletedFeeds);
    }
);
